module.exports = __webpack_public_path__ + "26b485e3a1ea967a639cfb1246e294a1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIDisplay-Light.ttf
// module id = 363
// module chunks = 0